import React from 'react';
import $ from "jquery";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Server from '../../../functions/server';
import { Button } from 'semantic-ui-react';
import MakeDecimalPoints from '../../makedecimalpoints';

class Payment extends React.Component {

    state = {
        data: []
    }

    view() {
        let context = this;
        context.setState({ 'fromDate': this.props.fromDate, 'toDate': this.props.toDate, load: true })
        $.ajax({
            type: 'POST', data: { 'id': context.props.id, 'fromDate': this.props.fromDate, 'toDate': this.props.toDate },
            url: Server()+'machine/statement/getcustomerstatement.php',
            success: function(data) {
                console.log(data);
                console.log('datatatat');
                try {
                    data = JSON.parse(data);
                    context.setState({ data, load: false, openDialog: true })
                } catch (error) {
                    alert('Try Agian!!!');
                    context.setState({ load: false })
                }
            },
            error: function(e) {
                alert('Try again!!')
            }
        });

    }

    convertIntoNumber(value) {
        try {
            value = Number(value);
        } catch (error) {
            value = 0;
        }
        return value;
    }

    render() {
        let sino = 1;
        return (
            <div>
                <b style={{cursor: 'pointer'}} onClick={this.view.bind(this)}>View</b>
                <Dialog fullWidth={true} maxWidth={'xm'} open={this.state.openDialog}
                    onClose={ () => { this.setState({ openDialog: false }) }}
                    aria-labelledby="max-width-dialog-title" >
                    <DialogTitle id="max-width-dialog-title">{this.props.name+' Statment'}</DialogTitle>
                    <DialogContent>
                        <div style={{textAlign: 'right', fontWeight: 'bold'}}>{'Closing Balance '+this.props.closingBalance}</div>
                        <table id="table" width="100%">
                            <tr id="th">
                                <th>Sino</th>
                                <th>Date</th>
                                <th>Voucher</th>
                                <th>Type</th>
                                <th>Inwards</th>
                                <th>Outwards</th>
                                <th>Remarks</th>
                            </tr>
                            {
                                this.state.data.map((c) => {
                                    let Inwards = '';
                                    let Outwards = '';
                                    let amount = this.convertIntoNumber(c.amount);
                                    if (c.type == 'Receipt') {
                                        Inwards = amount * -1;
                                        Inwards = 'Rs. '+MakeDecimalPoints(Inwards);
                                    }
                                    else {
                                        Outwards = amount;
                                        Outwards = 'Rs. '+MakeDecimalPoints(Outwards);
                                    }
                                    return (
                                        <tr>
                                            <td>{sino++}</td>
                                            <td>{c.date}</td>
                                            <td>{c.receipt_voucher}</td>
                                            <td>{c.type}</td>
                                            <td><div style={{textAlign: 'right', fontWeight: 'bold'}}>{Inwards}</div></td>
                                            <td><div style={{textAlign: 'right', fontWeight: 'bold'}}>{Outwards}</div></td>
                                            <td>{c.remark}</td>
                                        </tr>
                                    )
                                })
                            }
                        </table>
                        <div style={{textAlign: 'right', fontWeight: 'bold'}}>{'Opeining Balance '+this.props.openingBalance}</div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={ () => { this.setState({ openDialog: false }) }}>Close</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default Payment;
